export const PHONE = "+919414188860";
export const PHONE_DISPLAY = "+91 94141 88860";
export const CALL_URL = `tel:${PHONE}`;

export const whatsappUrl = (message = "Hello Garg Stone Company! I'd like a quote for Kota Stone.") =>
  `https://wa.me/${PHONE.replace("+", "")}?text=${encodeURIComponent(message)}`;

export const finishEnquiry = (finish) => whatsappUrl(
  `Hello Garg Stone Company! I'd like a quote for ${finish.name} (${finish.finish}). ` +
  `Please confirm available sizes, thickness, price, freight and lead time. ` +
  `My required quantity and delivery location: `
);

export const CNC_ENQUIRY = whatsappUrl(
  "Hello Garg Stone Company! I'm interested in CNC carved stone patterns. Please share available designs, actual carved sample photos, stone options, panel sizes, carving depths and a quote."
);